import React from 'react';
import PropTypes from 'prop-types';

/**
 * react-router v5 <Prompt> 兼容组件（降级实现）。
 *
 * react-router v6 移除了 <Prompt>，且普通 <BrowserRouter> 模式下
 * 没有官方的导航拦截 API（useBlocker 仅支持 createBrowserRouter 数据路由）。
 *
 * 行为说明：
 * - 浏览器刷新 / 关闭场景：由业务代码中已有的 useBeforeUnload（react-use）负责拦截；
 * - 应用内路由跳转：本组件不再拦截（原 v5 <Prompt> 行为），如需完整恢复，
 *   需将路由迁移到 createBrowserRouter 并使用 useBlocker。
 */
export default function RoutePrompt() {
    return null;
}

RoutePrompt.propTypes = {
    when: PropTypes.bool,
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
};
